module.exports = __webpack_public_path__ + "static/media/BetterShirt.acaed296.obj";


//////////////////
// WEBPACK FOOTER
// ./src/3dmodels/Tshirt1/BetterTShirt/BetterShirt.obj
// module id = 81
// module chunks = 0